import { LOGIN } from '../actions';

export const initialState = {
  error: null
};

export const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN._REQUEST: {
      state.error = null;
      return state;
    }
    case LOGIN._ERROR: {
      state.error = action.error;
      return state;
    }
    default:
      return state;
  }
};
